import { Text } from '@mantine/core';

import { useTranslation } from '@apple/lib/i18next';
import { DefaultPieChart } from '@apple/ui/charts/DefaultPieChart';
import { useBreakpoints } from '@apple/ui/layouts/hooks/useBreakpoints';

import type { BudgetDetailsItem } from '../models/budget';

export interface BudgetDetailsTableProps {
	budgetDetailData: BudgetDetailsItem[];
	isLoading: boolean;
	isFetching: boolean;
}

export function BudgetPieChart({
	budgetDetailData,
	isLoading,
	isFetching,
}: BudgetDetailsTableProps) {
	const { t } = useTranslation('common');
	const { mdOrLarger } = useBreakpoints();

	const pieChartData =
		!isLoading && !isFetching
			? budgetDetailData.map((x, _index) => ({
					name: x.categoryName,
					value: x.percentOfTotalBudget,
					tooltip: <Text>{`${x.amountSpent} - ${x.formattedPercentOfTotalBudget}`}</Text>,
				}))
			: [];

	return (
		<DefaultPieChart
			withTooltip
			tooltipDataSource='segment'
			size={350}
			data={pieChartData}
			withLabels
			labelsType='percent'
			labelsPosition='inside'
			groupBelowPercent={5}
			legendPosition={mdOrLarger ? 'right' : 'bottom'}
			groupLabel={t('label.other')}
		/>
	);
}
